// React
import { Fragment, useEffect } from "react"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Types
import { FormType } from "../../utils"

// Utils
import { useDataCode } from "./utils"

export function Code(params: {
  returncode: string
  jenis: number
}): JSX.Element {
  // Hooks
  const { data, refetch } = useDataCode()

  // Form
  const { control, setValue } = useFormContext<FormType>()
  const transaction_date = useWatch({
    control,
    name: "transaction_date"
  })
  
  useEffect(() => {
    refetch({
      ...params,
      date_request: transaction_date
    })
    setValue("trx_code",data)
    // eslint-disable-next-line
  }, [transaction_date, data])
  
  return <Fragment>{data}</Fragment>
}